import styled from 'styled-components'

export const PopupInstanceDetector = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 2rem 2rem 0;
  color: #fff;
  border-radius: 0.4rem;
  z-index: 1;
`

export const ConnectAppButton = styled.button`
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: ${({ theme }) => theme.button.primary.backgroundColor};
  color: ${({ theme }) => theme.button.primary.color};
  border: none;
  border-radius: 4px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.button.primary.backgroundColorHover};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const AccountActionsRow = styled.div<{ $isLoading?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0.5rem;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  pointer-events: ${({ $isLoading }) => ($isLoading ? 'none' : 'auto')};
`

export const AccountActionLink = styled.button`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.color.primary};
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`
